import sanitizeHtml from "sanitize-html";
import { DirectiveBinding } from "vue";

/**
 * Sanitize HTML
 * It will sanitize the HTML with the default sanitize-html options (https://www.npmjs.com/package/sanitize-html#default-options)
 *
 * Inspired by https://github.com/leopiccionia/vue-sanitize-directive/blob/master/src/index.js
 */
function sanitize(el: HTMLElement, binding: DirectiveBinding): void {
  if (binding.value !== binding.oldValue) {
    if (Array.isArray(binding.value)) {
      el.innerHTML = sanitizeHtml(binding.value[1], binding.value[0]);
    } else {
      // Also allow the <img> tag with all of its attributes
      el.innerHTML = sanitizeHtml(binding.value, {
        allowedTags: sanitizeHtml.defaults.allowedTags.concat([
          "img",
          "strong",
          "a",
        ]),
        allowedAttributes: {
          ...sanitizeHtml.defaults.allowedAttributes,
          a: ["href", "name", "target"],
          img: ["src", "alt"],
        },
      });
    }
  }
}

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding): void {
    sanitize(el, binding);
  },
};
